export default "__VITE_ASSET__DgqdQbSs__"